<template>
  <!-- <div id="app" :style="{ width: isMobileRestricted ? '100%' : '1920px' }"> -->
  <div id="app" :style="{ width: '100%' }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>
  </div>
</template>

<script>
import router from './router';

export default {
  name: 'App',
  data () {
    return {
      isMobileRestricted: true
    }
  },
  mounted () {
    this.setupRouterGuard();
  },

  methods: {
    setupRouterGuard () {

      router.beforeEach((to, from, next) => {
        if (to.meta.disableMediaQuery) {
          // 如果目标路由设置了 disableMediaQuery 为 true，则不受媒体查询限制
          this.isMobileRestricted = true;
        } else {
          // 其他页面默认受媒体查询限制
          this.isMobileRestricted = false;
        }
        next();
      });
    }

  },

}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
}

/* 兼容移动端 */
/* @media screen and (max-width:750px) {
  #app {
    width: 1920px;
  }
} */
html,
body,
#app {
  height: 100%;
}

    /* 自定义滚动条整体样式 */
 ::-webkit-scrollbar {
     width: 12px; /* 水平滚动条的高度、垂直滚动条的宽度 */
     background-color: #aba8ab;
 }
 
 /* 自定义滚动条轨道样式 */
 ::-webkit-scrollbar-track {
     background: #f5f5f1; /* 可以是透明的 */
     border-radius: 10px;
 }
 
 /* 自定义滚动条滑块样式 */
 ::-webkit-scrollbar-thumb {
     background-color: #9da1a5;
     border-radius: 10px;
     border: 2px solid #b3b1ad; /* 可选的，为滑块添加边框 */
 }
 
 /* 滚动条在悬停或者点击时的样式 */
 ::-webkit-scrollbar-thumb:hover {
    background: #b8b5b5;
 }


</style>



// WEBPACK FOOTER //
// src/App.vue